export default __webpack_public_path__ + "static/media/label-18.103a3953.svg";